class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('div.predictsearch');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  } 

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;
    
    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = ''; 

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);
 
    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
     var url = window.location.href;
    var url1 = url.split("/");
     fetch(url1[0]+`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search&&${encodeURIComponent('resources[options][fields]')}=title,variants.sku,tag`)
      .then((response) => { 
   
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        
     
        return response.text();
      })
      .then((text) => {
     
       var html=''; 
       var obj = jQuery.parseJSON(text);
      var res = obj.resources.results.products;
       if(res != ''){
              
      $.each( res, function( key, value ) {
        var discount = '';
        if(value.compare_at_price != null){
              discount = (value.price * 100)/value.compare_at_price;
            
        }
         var a = value.url;
         var b = a.split("?");
  html+='<div class="col">'
html+='<div class="card-wrapper position-relative">'
  html+='<a href="'+b[0]+'" class="full-unstyled-link">'
    html+='<span class="visually-hidden">Aarah Coral Shirt in Chanderi</span>'
    html+='<div class="card rounded-0 border-0 bg-transparent" tabindex="-1"><div class="media media--transparent media--adapt media--hover-effect" style="padding-bottom: 154.9019608%;">'
          html+='<img srcset="'+value.image+'" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="'+value.title+'" loading="lazy" class="motion-reduce" width="1836" height="2844"><img srcset="'+value.image+'" src="'+value.image+'" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="'+value.title+'" loading="lazy" class="motion-reduce" width="1836" height="2844"></div>'
  if(value.compare_at_price != null){
          html+='<div class="off-mark">'
       html+='<span class="badge rounded-0 fw-normal color-inverse" aria-hidden="true">'
        html+='<font>'+discount+'%</font>'
      html+='</span>'
    html+='</div>'
  }
      html+='<div class="card-body px-0">'
        html+='<div class="row g-0">'
          html+='<div class="col-lg-6 pe-2">'+value.title+'</div>'
          html+='<div class="col-lg-6 text-lg-end">'
            
html+='<div class="price justify-content-end price--on-sale ">'
  html+='<dl><div class="price__regular">'
      html+='<dt>'
        html+='<span class="visually-hidden visually-hidden--inline">Regular price</span>'
      html+='</dt>'
      html+='<dd>'
        html+='<span class="price-item price-item--regular text-primary">₹'+value.price+'</span>'
      html+='</dd>'
    html+='</div>'
    html+='<div class="price__sale">'
      html+='<dt class="price__compare">'
        html+='<span class="visually-hidden visually-hidden--inline">Regular price</span>'
      html+='</dt>'
      if(value.compare_at_price != null){
      html+='<dd class="price__compare">'
        html+='<s class="price-item price-item--regular">₹'+value.compare_at_price+'</s>'
      html+='</dd>'
      }
      html+='<dt>'
        html+='<span class="visually-hidden visually-hidden--inline">Sale price</span>'
      html+='</dt>'
      html+='<dd>'
        html+='<span class="price-item price-item--sale text-primary">₹'+value.price+'</span>'
      html+='</dd>'
    html+='</div>'
    html+='<small class="unit-price caption d-none">'
      html+='<dt class="visually-hidden">Unit price</dt>'
      html+='<dd>'
        html+='<span></span>'
        html+='<span aria-hidden="true">/</span>'
        html+='<span class="visually-hidden">&nbsp;per&nbsp;</span>'
        html+='<span>'
        html+='</span>'
      html+='</dd>'
    html+='</small>'
  html+='</dl></div>'
          html+='</div>'
        html+='</div>'
      html+='</div>'
    html+='</div>'
  html+='</a>'
html+='</div>'
     html+='</div>'
      });
      
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('.template-search__results');
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      }else{
       
      html+='<p>Products not found.</p>'
      }
       $(".predict_data").html(html);
      })
      .catch((error) => {
        this.close();
        throw error;
      }); 
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);  

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() { 
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]'));
  } 

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close(clearSearchTerm = false) { 
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);